import React from 'react'
import { Redirect, Route } from 'react-router-dom'

// /public/register was the old, unstyled registration page. Registration now
// lives in the sign-in journey at /auth/register (auth/page/register.js);
// this keeps any old link or bookmark working, router state included.
export const LayoutRegister = () =>
  <Route
    path="/public/register"
    render={({ location }) => <Redirect to={{ pathname: '/auth/register', search: location.search, state: location.state }} />}
  />
